__turbopack_context__.v({
  "channel": "ZgtiYa_channel",
  "livetv_row": "ZgtiYa_livetv_row",
  "livetv_row__loading": "ZgtiYa_livetv_row__loading",
  "livetv_row__splide_arrow": "ZgtiYa_livetv_row__splide_arrow",
  "livetv_row_title": "ZgtiYa_livetv_row_title",
});
